import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getPetitionDetailsPageData } from './api';
import type { PetitionDetailsPageDataErrorCode } from './types';

export const {
	Context: PetitionDetailsPageDataContext,
	Provider: PetitionDetailsPageDataContextProvider,
	useContext: usePetitionDetailsPageData,
	useAsyncData: usePetitionDetailsPageDataFromApi,
	prefetchAsyncData: prefetchPetitionDetailsPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'PetitionDetailsPageDataContext',
	dataProperty: 'pageData',
	getData: getPetitionDetailsPageData,
	getUniqueId: (slug, { countryCode, locale, isBot }) => [slug, countryCode, locale, isBot].join(','),
	hookDeps: (slug, { countryCode, locale, isBot }) => [slug, countryCode, locale, isBot],
	errorHandler: pageDataErrorHandler<PetitionDetailsPageDataErrorCode>(),
});
